/**
 * Created by Usuario 06 on 27-08-2016.
 */

angular.module('cloudxcmClientsApp').filter('uppercase', function() {
  return function(input) {
    return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
  }
});
